import { useState, useEffect } from "preact/hooks";
import { formatTimeAgo } from "../utils/format";

type LastUpdatedProps = {
  timestamp: string | null;
};

export function LastUpdated({ timestamp }: LastUpdatedProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((t) => t + 1), 10000);
    return () => window.clearInterval(id);
  }, []);

  if (!timestamp) {
    return <span class="last-updated">Belum diperbarui</span>;
  }

  return (
    <span class="last-updated" title={timestamp}>
      Diperbarui: {formatTimeAgo(timestamp)}
    </span>
  );
}
